export default __webpack_public_path__ + "static/media/italygot-screenshot-02.df1c470b.png";